import type { ItemType } from './item-types';

const IMAGE_CODE: Record<ItemType, string> = {
  PART: 'PN',
  SET: 'SN',
  MINIFIG: 'MN',
  BOOK: 'BN',
  GEAR: 'GN',
  CATALOG: 'CN',
  INSTRUCTION: 'IN',
  ORIGINAL_BOX: 'ON',
  UNSORTED_LOT: 'UN',
};

/**
 * BrickLink's picture for an item in a colour. Only parts vary by colour. These are links to
 * BrickLink's servers, not copies, so check their terms before caching the images.
 */
export function blImageUrl(itemType: ItemType, itemNo: string, colorId: number): string {
  const color = itemType === 'PART' || itemType === 'UNSORTED_LOT' ? colorId : 0;
  return `https://img.bricklink.com/ItemImage/${IMAGE_CODE[itemType]}/${color}/${encodeURIComponent(itemNo)}.png`;
}
